import React from "react";
import { connect } from "react-redux";

import { doGetAllOrdersDispatched } from "../stores/thunk";
import { selectAllReports } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      action: state.report.action,
      isFetching: state.report.isFetching,
      status: state.report.status,
      metadata: state.report.metadata,
      user: state.auth.user,
      message: state.report.message,
      orders: selectAllReports(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllOrdersDispatched,
  })(Container);
};
